import type { InitializePaddleOptions, Paddle } from "@paddle/paddle-js";
import { REACT_APP__BILLING_PADDLE_CLIENT_SIDE_TOKEN } from "@smp/utils";
import { useEffect, useState } from "react";

export function usePaddle(
  eventCallback?: InitializePaddleOptions["eventCallback"],
) {
  const [paddle, setPaddle] = useState<Paddle>();

  useEffect(() => {
    async function initPaddle() {
      if (REACT_APP__BILLING_PADDLE_CLIENT_SIDE_TOKEN) {
        const { initializePaddle } = await import("@paddle/paddle-js");

        const paddleInstance = await initializePaddle({
          environment: "sandbox",
          token: REACT_APP__BILLING_PADDLE_CLIENT_SIDE_TOKEN,
          eventCallback,
        });
        setPaddle(paddleInstance);
      } else {
        console.error(
          "env REACT_APP__BILLING_PADDLE_CLIENT_SIDE_TOKEN is required!",
        );
      }
    }

    initPaddle();
  }, [eventCallback]);

  return paddle;
}
